import {ChangeDetectorRef, Component, ElementRef, Input} from "@angular/core";
import {FUIAbstractPop, PopParentHorizontalAlignment, PopParentVerticalAlignment} from "../../pops/abstract-pop";
import {FUIPopsService} from "../../pops/pops.service";
import {FUIFormContext} from "../../form-context/form-context";
import {FUIPopFormContext} from "../../form-context/pop-form-context";
import {FUIEventsService} from "../../events/events.service";
import {FUIResponsiveService} from "../../page/responsive.service";

@Component({
    providers: [{provide: FUIFormContext, useClass: FUIPopFormContext}],
    selector: "fui-command-pop",
    styleUrls: ["./command-pop.component.scss"],
    templateUrl: "./command-pop.component.html"
})
export class FUICommandPopComponent extends FUIAbstractPop {
    @Input() parentHorizontalAlignment: PopParentHorizontalAlignment = PopParentHorizontalAlignment.LEFT;

    parentVerticalAlignment: PopParentVerticalAlignment = PopParentVerticalAlignment.DYNAMIC;
    limitWidthToParent: boolean = false;
    adjustHeightToFirstElement: boolean = true;

    constructor(changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                eventsService: FUIEventsService,
                popsService: FUIPopsService,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, elementRef, eventsService, popsService, responsiveService);
    }
}
